import React from 'react';
import Wrapper from 'components/Wrapper';
import Text from 'components/Text';
import { fontSizes } from 'appconstants';
import { ReactSVG } from 'react-svg';
import { back_icon } from 'asset/icons';
import { useNavigate } from 'react-router-dom';
import SectionCard from 'components/SectionCard';
import RowView from 'components/RowView';

const StoresView = () => {
  const navigate = useNavigate();

  const stores = [1, 2]; // scalable

  return (
    <Wrapper>
      <div className='flex items-center gap-3 mb-6'>
        <div
          onClick={() => navigate(-1)}
          className='h-10 w-10 cursor-pointer rounded-md flex items-center justify-center bg-muted hover:bg-muted/50 transition'
        >
          <ReactSVG src={back_icon} />
        </div>
        <Text text='Stores' size={fontSizes.h24} className='font-bold' />
      </div>

      {stores.map((store) => (
        <div key={store} className='mb-14'>
          <Text text={`Store ${store}`} size={fontSizes.h26} className='font-bold mt-5 mb-4' />

          <div className='grid grid-cols-1 lg:grid-cols-2 gap-6'>
            <div className='space-y-6'>
              <SectionCard title='General'>
                <RowView label='Store Name' value='Green Valley Grocery' />
                <RowView label='Store Number' value='ST-045' />
                <RowView label='Store Address' value='123 Market Street, Downtown, Karachi' />
                <RowView
                  label='Store Contacts'
                  value='Ali Khan – Store Manager, +92 300 1234567'
                  className='flex-col gap-3'
                  detailTextClassName='text-left'
                />
                <RowView
                  label='Store Feedback'
                  value='Products well-stocked, no complaints from customers, staff cooperative.'
                  className='flex-col gap-3 border-b-0'
                  detailTextClassName='text-left'
                />
              </SectionCard>

              <SectionCard title='Organic Display'>
                <RowView label='OG Label' value='Not present' />
                <RowView
                  label='Display Quality'
                  value='Fair – some fruits overripe, restocking needed'
                  className='border-b-0 flex-col gap-3'
                  detailTextClassName='text-left'
                />
              </SectionCard>

              <SectionCard title='Backroom'>
                <RowView label='Number of Boxes' value='14' />
                <RowView
                  label='CV Quality'
                  value='High – all fruits firm, evenly colored, no defects'
                  className='flex-col gap-3'
                  detailTextClassName='text-left'
                />
                <RowView label='OG Quality' value='Excellent – all labeled fruits fresh and uniform' className='border-b-0' />
              </SectionCard>
            </div>

            <SectionCard title='Retail Display'>
              <RowView label='CV Label' value='Dole' />
              <RowView label='Country of Origin' value='Brazil' />
              <RowView label='Farm Code' value='MNG-045' />
              <RowView label='CV Label 2' value='CV Label 2' />
              <RowView label='Country of Origin 2' value='Mexico' />
              <RowView label='Farm Code 2' value='MNG-045' />
              <RowView label='Price' value='$2.50 each' />
              <RowView
                label='Display Quality'
                value='Fair – some discolored items, needs restocking'
                className='flex-col gap-3'
                detailTextClassName='text-left'
              />
              <RowView label='Defects' value='No visible defects' />
              <RowView label='Layers' value='Single layer' />
              <RowView label='Fruit Under Display' value='All fruits firm and fresh' />
              <RowView label='Fullness' value='Partially stocked – needs restocking' />
              <RowView label='Average Color' value='Golden orange (mangoes)' />
              <RowView label='Pad Type' value='Paper cushion' className='border-b-0' />
            </SectionCard>
          </div>

          <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6'>
            <SectionCard title='Specialty Display'>
              <RowView label='Brand' value='Golden Harvest' className='border-b-0' />
            </SectionCard>

            <SectionCard title='Secondary Display'>
              <RowView label='Location' value='Refrigerated section, left side' className='border-b-0' />
            </SectionCard>
          </div>
        </div>
      ))}
    </Wrapper>
  );
};

export default StoresView;
